declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const META_PIXEL_ID = "1062673796741726";

/**
 * Meta's own loader, verbatim, followed by init and the first PageView.
 *
 * Rendered into <head> by the root route when the request may carry the
 * pixel, and executed by loadPixel() the moment a visitor in a consent region
 * says yes. One string, so the two paths cannot diverge.
 */
export const PIXEL_BOOTSTRAP = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');`;

/**
 * Loads the pixel after consent. Safe to call twice: Meta's loader returns
 * early once fbq exists, and so does this.
 */
export function loadPixel() {
  if (typeof window === "undefined" || window.fbq) return;
  const script = document.createElement("script");
  script.text = PIXEL_BOOTSTRAP;
  document.head.appendChild(script);
}

export function trackPixel(event: string, params?: Record<string, unknown>, eventId?: string) {
  // The id must reach Meta on both copies of the event or the server-side
  // duplicate from meta-capi.server.ts is counted as a second lead.
  if (eventId) window.fbq?.("track", event, params, { eventID: eventId });
  else window.fbq?.("track", event, params);
}

export function trackPixelCustom(event: string, params?: Record<string, unknown>) {
  window.fbq?.("trackCustom", event, params);
}
